import React from 'react';
import { Link } from 'react-router-dom';
import {
  FiPenTool,
  FiLayout,
  FiGlobe,
  FiInstagram,
  FiTrendingUp,
  FiArrowUpRight,
} from 'react-icons/fi';
import './Services.css';
import ShyneService from '../../Components/Assets/ShyneService.png';

const services = [
  {
    title: 'Branding',
    icon: <FiLayout />,
    description:
      'Complete branding solutions including color palettes, typography, and visual direction to give your business a polished and consistent look.',
    link: '/services/branding',
  },
  {
    title: 'Logo Design',
    icon: <FiPenTool />,
    description:
      'Custom logo designs that help your business make a strong first impression, build trust, and create a memorable visual identity.',
    link: '/services/logo-design',
  },
  {
    title: 'Website Design',
    icon: <FiGlobe />,
    description:
      'Modern, responsive websites built to look polished, load smoothly, and turn visitors into real leads for your business.',
    link: '/services/web-design',
  },
  {
    title: 'Social Media Design',
    icon: <FiInstagram />,
    description:
      'Creative social media graphics and branded content that help your business stand out across Instagram, Facebook, and other platforms.',
    link: '/services/social-media-design',
  },
  {
    title: 'SEO & Digital Marketing',
    icon: <FiTrendingUp />,
    description:
      'Strategy-driven marketing support to improve visibility, attract traffic, and help your business grow online with confidence.',
    link: '/services/seo-marketing',
  },
];

function Services() {
  return (
    <section className="servicesPage">
      {/* HERO BACKGROUND */}
      <div
        className="servicesHero"
        style={{ backgroundImage: `url(${ShyneService})` }}
      >

    <div className="servicesHeroContent">
        <h2>Professional Design & Digital Services</h2>
        <p>
        From branding to websites and marketing, Shyne Graphics helps businesses
        stand out, grow faster, and convert more customers with confidence.
        </p>
    </div>       

        {/* WHITE CONTAINER */}
        <div className="servicesShell">
          {/* INTRO */}
          <div className="servicesIntro">
            <span className="servicesEyebrow">Our Services</span>

            <h1>Creative Services Designed to Help Your Business Grow</h1>

            <p>
              From logo design and branding to websites and digital marketing,
              Shyne Graphics creates visuals and strategies that help businesses
              stand out and convert with confidence.
            </p>
          </div>

          {/* GRID */}
          <div className="servicesGrid">
            {services.map((service, index) => (
              <article className="serviceBox" key={index}>
                <div className="serviceIcon">{service.icon}</div>

                <h3>{service.title}</h3>

                <p>{service.description}</p>

                <Link to={service.link} className="serviceBtn">
                  Learn More
                  <FiArrowUpRight />
                </Link>
              </article>
            ))}

            {/* CTA BOX */}
            <article className="serviceBox serviceBox--cta">
              <div className="serviceIcon serviceIcon--cta">
                <FiArrowUpRight />
              </div>

              <h3>Let’s Build Your Brand</h3>

              <p>
                Ready to elevate your business with strong design and digital
                marketing? Let’s create something that gets attention and drives
                results.
              </p>

              <Link to="/#contact" className="serviceBtn serviceBtn--dark">
                Request a Quote
                <FiArrowUpRight />
              </Link>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;